import styled from 'styled-components';
import { TextEllipsis } from 'styles/mixins';

export const Container = styled.span`
  line-height: initial;
  ${TextEllipsis}
`;
